import React from 'react';
import PropTypes from 'prop-types';

import { useInterval } from '@tzmedical/react-hooks';

import axios from '../axiosClient.js';

const CommissionsPermissionsContext = React.createContext();
const REFRESH_INTERVAL_MS = 300_000;

export function CommissionsPermissionsProvider({ children }) {
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [commissionsPermissions, setCommissionsPermissions] = React.useState([]);

  const checkCommissionsPermissions = React.useCallback(async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: '/api/permissions/commissions',
      });

      if (data.length === 0) {
        setError('No user permissions found');
        setCommissionsPermissions([]);
        setLoading(false);
        return;
      }

      setCommissionsPermissions(data);
      setError(null);
      setLoading(false);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      setLoading(false);
    }
  }, []);

  useInterval(checkCommissionsPermissions, REFRESH_INTERVAL_MS, loading && !error);

  const value = React.useMemo(
    () => ({
      commissionsPermissions,
      error,
      loading,
      refreshCommissionsPermissions: checkCommissionsPermissions,
    }),
    [commissionsPermissions, error, loading, checkCommissionsPermissions]
  );

  return (
    <CommissionsPermissionsContext.Provider value={value}>
      {children}
    </CommissionsPermissionsContext.Provider>
  );
}

CommissionsPermissionsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CommissionsPermissionsContext;
